import React from 'react';
import './Contact.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaMapMarkerAlt, FaPhone } from 'react-icons/fa';

function Contact() {
  return (
    <Container fluid className="contact-us-container d-flex justify-content-center align-items-center py-5">
      <Row className="justify-content-center w-100">
        <Col xs={12} sm={10} md={8} lg={6} className="p-0">
          <div className="outlet">
            <h2>Ladiva FAMILY SALON & MAKEUP STUDIO</h2>
            <div className="contact-details">
              <div className="info-row">
                <a href="https://maps.app.goo.gl/bJzaSGzzx32F4Aqm9?g_st=iw" target="_blank" rel="noopener noreferrer" className="icon-link" aria-label="Open Map">
                  <FaMapMarkerAlt />
                </a>
                <div className="info-text">
                  Near Pattom granites and tiles<br />
                  Kaniyanthodu, mukhathala- 691577
                </div>
              </div>
              
              <div className="info-row">
                <a href="tel:+918590248482" className="icon-link" aria-label="Call Us">
                  <FaPhone />
                </a>
                <div className="info-text">
                  +91 8590248482 , +91 7511134484<br />
                  +91 9061575474
                </div>
              </div>
            </div>

            <h3 className="mt-4">SERVICES :</h3>
            <ul>
              <li>&#9670; All hair and beauty services</li>
              <li>&#9670; Bride & Groom Makeup</li>
              <li>&#9670; Microblading</li>
              <li>&#9670; and more...</li>
            </ul>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Contact;
